<template>
  <div v-if="router.currentRoute.value.path === '/'" class="component-wrap fix-margin-top">
    <div  class="content-header">
      <div class="title">
        <h2>{{ $t("app.invoice-overview.title") }}</h2>
      </div>
      <div v-if="!isBurger" class="view-buttons">
        <div
          class="grid-view"
          @click="changeLayout(false)"
          :class="{ active: !isListView }"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.42857C0 1.04969 0.15051 0.686328 0.418419 0.418419C0.686328 0.15051 1.04969 0 1.42857 0H4.28571C4.6646 0 5.02796 0.15051 5.29587 0.418419C5.56378 0.686328 5.71429 1.04969 5.71429 1.42857V4.28571C5.71429 4.6646 5.56378 5.02796 5.29587 5.29587C5.02796 5.56378 4.6646 5.71429 4.28571 5.71429H1.42857C1.04969 5.71429 0.686328 5.56378 0.418419 5.29587C0.15051 5.02796 0 4.6646 0 4.28571V1.42857ZM7.14286 1.42857C7.14286 1.04969 7.29337 0.686328 7.56128 0.418419C7.82919 0.15051 8.19255 0 8.57143 0H11.4286C11.8075 0 12.1708 0.15051 12.4387 0.418419C12.7066 0.686328 12.8571 1.04969 12.8571 1.42857V4.28571C12.8571 4.6646 12.7066 5.02796 12.4387 5.29587C12.1708 5.56378 11.8075 5.71429 11.4286 5.71429H8.57143C8.19255 5.71429 7.82919 5.56378 7.56128 5.29587C7.29337 5.02796 7.14286 4.6646 7.14286 4.28571V1.42857ZM14.2857 1.42857C14.2857 1.04969 14.4362 0.686328 14.7041 0.418419C14.972 0.15051 15.3354 0 15.7143 0H18.5714C18.9503 0 19.3137 0.15051 19.5816 0.418419C19.8495 0.686328 20 1.04969 20 1.42857V4.28571C20 4.6646 19.8495 5.02796 19.5816 5.29587C19.3137 5.56378 18.9503 5.71429 18.5714 5.71429H15.7143C15.3354 5.71429 14.972 5.56378 14.7041 5.29587C14.4362 5.02796 14.2857 4.6646 14.2857 4.28571V1.42857ZM0 8.57143C0 8.19255 0.15051 7.82919 0.418419 7.56128C0.686328 7.29337 1.04969 7.14286 1.42857 7.14286H4.28571C4.6646 7.14286 5.02796 7.29337 5.29587 7.56128C5.56378 7.82919 5.71429 8.19255 5.71429 8.57143V11.4286C5.71429 11.8075 5.56378 12.1708 5.29587 12.4387C5.02796 12.7066 4.6646 12.8571 4.28571 12.8571H1.42857C1.04969 12.8571 0.686328 12.7066 0.418419 12.4387C0.15051 12.1708 0 11.8075 0 11.4286V8.57143ZM7.14286 8.57143C7.14286 8.19255 7.29337 7.82919 7.56128 7.56128C7.82919 7.29337 8.19255 7.14286 8.57143 7.14286H11.4286C11.8075 7.14286 12.1708 7.29337 12.4387 7.56128C12.7066 7.82919 12.8571 8.19255 12.8571 8.57143V11.4286C12.8571 11.8075 12.7066 12.1708 12.4387 12.4387C12.1708 12.7066 11.8075 12.8571 11.4286 12.8571H8.57143C8.19255 12.8571 7.82919 12.7066 7.56128 12.4387C7.29337 12.1708 7.14286 11.8075 7.14286 11.4286V8.57143ZM14.2857 8.57143C14.2857 8.19255 14.4362 7.82919 14.7041 7.56128C14.972 7.29337 15.3354 7.14286 15.7143 7.14286H18.5714C18.9503 7.14286 19.3137 7.29337 19.5816 7.56128C19.8495 7.82919 20 8.19255 20 8.57143V11.4286C20 11.8075 19.8495 12.1708 19.5816 12.4387C19.3137 12.7066 18.9503 12.8571 18.5714 12.8571H15.7143C15.3354 12.8571 14.972 12.7066 14.7041 12.4387C14.4362 12.1708 14.2857 11.8075 14.2857 11.4286V8.57143ZM0 15.7143C0 15.3354 0.15051 14.972 0.418419 14.7041C0.686328 14.4362 1.04969 14.2857 1.42857 14.2857H4.28571C4.6646 14.2857 5.02796 14.4362 5.29587 14.7041C5.56378 14.972 5.71429 15.3354 5.71429 15.7143V18.5714C5.71429 18.9503 5.56378 19.3137 5.29587 19.5816C5.02796 19.8495 4.6646 20 4.28571 20H1.42857C1.04969 20 0.686328 19.8495 0.418419 19.5816C0.15051 19.3137 0 18.9503 0 18.5714V15.7143ZM7.14286 15.7143C7.14286 15.3354 7.29337 14.972 7.56128 14.7041C7.82919 14.4362 8.19255 14.2857 8.57143 14.2857H11.4286C11.8075 14.2857 12.1708 14.4362 12.4387 14.7041C12.7066 14.972 12.8571 15.3354 12.8571 15.7143V18.5714C12.8571 18.9503 12.7066 19.3137 12.4387 19.5816C12.1708 19.8495 11.8075 20 11.4286 20H8.57143C8.19255 20 7.82919 19.8495 7.56128 19.5816C7.29337 19.3137 7.14286 18.9503 7.14286 18.5714V15.7143ZM14.2857 15.7143C14.2857 15.3354 14.4362 14.972 14.7041 14.7041C14.972 14.4362 15.3354 14.2857 15.7143 14.2857H18.5714C18.9503 14.2857 19.3137 14.4362 19.5816 14.7041C19.8495 14.972 20 15.3354 20 15.7143V18.5714C20 18.9503 19.8495 19.3137 19.5816 19.5816C19.3137 19.8495 18.9503 20 18.5714 20H15.7143C15.3354 20 14.972 19.8495 14.7041 19.5816C14.4362 19.3137 14.2857 18.9503 14.2857 18.5714V15.7143Z"
              fill="#DDDFE4"
            />
          </svg>
        </div>
        <div
          class="list-view"
          @click="changeLayout(true)"
          :class="{ active: isListView }"
        >
          <svg
            width="23"
            height="20"
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.66665 8.21429V11.7857C6.66665 12.3775 6.18696 12.8571 5.59522 12.8571H1.07143C0.479688 12.8571 0 12.3775 0 11.7857V8.21429C0 7.62254 0.479688 7.14286 1.07143 7.14286H5.59522C6.18696 7.14286 6.66665 7.62254 6.66665 8.21429ZM0 15.3571V18.9286C0 19.5203 0.479688 20 1.07143 20H5.59522C6.18696 20 6.66665 19.5203 6.66665 18.9286V15.3571C6.66665 14.7654 6.18696 14.2857 5.59522 14.2857H1.07143C0.479688 14.2857 0 14.7654 0 15.3571ZM5.59522 0H1.07143C0.479688 0 0 0.479688 0 1.07143V4.64286C0 5.2346 0.479688 5.71429 1.07143 5.71429H5.59522C6.18696 5.71429 6.66665 5.2346 6.66665 4.64286V1.07143C6.66665 0.479688 6.18696 0 5.59522 0ZM9.16665 20H21.7857C22.3775 20 22.8571 19.5203 22.8571 18.9286V15.3571C22.8571 14.7654 22.3775 14.2857 21.7857 14.2857H9.16665C8.57491 14.2857 8.09522 14.7654 8.09522 15.3571V18.9286C8.09522 19.5203 8.57491 20 9.16665 20ZM8.09522 1.07143V4.64286C8.09522 5.2346 8.57491 5.71429 9.16665 5.71429H21.7857C22.3775 5.71429 22.8571 5.2346 22.8571 4.64286V1.07143C22.8571 0.479688 22.3775 0 21.7857 0H9.16665C8.57491 0 8.09522 0.479688 8.09522 1.07143ZM9.16665 12.8571H21.7857C22.3775 12.8571 22.8571 12.3775 22.8571 11.7857V8.21429C22.8571 7.62254 22.3775 7.14286 21.7857 7.14286H9.16665C8.57491 7.14286 8.09522 7.62254 8.09522 8.21429V11.7857C8.09522 12.3775 8.57491 12.8571 9.16665 12.8571Z"
              fill="#DDDFE4"
            />
          </svg>
        </div>
      </div>
    </div>
    <div v-if="!isBurger" class="content-bar">
      <div class="content-bar-left">
        <SearchInput
          :placeholder="$t('app.invoice-overview.searchInput')"
          :reset="resetSearch"
          @search="search"
        />
        <!-- <BaseSelect
          :options="transactionTypes"
          :placeholder="$t('app.invoice-overview.transType')"
          :value ="selectedTransactionTypeName"
          @selected="setSelectedTransactionType"
        /> -->
        <dropdown-one
          v-model="selectedTransactionType"
          :dropdownLabel="'label'"
          :options="TRANSACTION_TYPE_NEW"
          class="mt-5 mr-spacing input-wrap-apply"
          :placeholder="$t('app.create-invoice.transactionType')"
          :label="''"
          :translate="true"
          :erasable="true"
          @delete="removeSelectedTransactionTypeNew"
          @optionSelected="setSelectedTransactionTypeNew"
        />
        <!-- <BaseSelect
          :options="invoiceTypes"
          :placeholder="$t('app.invoice-overview.invType')"
          :value ="selectedInvoiceTypeName"
          @selected="setSelectedInvoiceType"
        /> -->
        <dropdown-one
          v-model="selectedInvoiceType"
          :dropdownLabel="'label'"
          :options="INVOICE_TYPES_NEW"
          class="mt-5 mr-spacing input-wrap-apply"
          :placeholder="$t('app.create-invoice.invoiceType')"
          :label="''"
          :translate="true"
          :erasable="true"
          @delete="removeSelectedInvoiceTypeNew"
          @optionSelected="setSelectedInvoiceTypeNew"
        />
      </div>
      <div class="content-bar-right">
        <DateInput 
          :placeholder="$t('app.invoice-overview.dateFrom')"
          :max="to"
          :reset="resetSearch"
          @input="(val) => (from = val)"
        />
        <DateInput 
          @input="(val) => (to = val)"
          :min="from"
          :reset="resetSearch"
          :placeholder="$t('app.invoice-overview.dateTo')" 
        />
        <div class="wrapCheckBox">
          <input type="checkbox" v-model="list_failed" name="" id="list_failed">
          <label for="list_failed">Prikaži neuspele račune</label>
        </div>
        
        <button class="btn gen" @click="getReset">
          {{ $t("app.invoice-overview.resetBtn") }}
        </button>
        <button class="btn new" @click="goToCreateInvoice">
          {{ $t("app.invoice-overview.newInvoiceBtn") }}
        </button>
      </div>
    </div>
    <div v-if="isBurger" class="mobile-filter-bar">
      <div class="options">
        <SearchInput 
        :placeholder="$t('app.invoice-overview.searchInput')"
        :reset="resetSearch"
         @search="search"/>
        <div class="options-right">
          <button 
          @click="showHideFilters"
          class="filter">
            {{ $t("app.invoice-overview.filterBtn") }}
          </button>
          <button class="create-invoice">
            <span class="material-symbols-rounded" @click="goToCreateInvoice">
              add
            </span>
          </button>
        </div>
      </div>
    <transition name="fadeHeight" mode="out-in">

      <div v-if="showFilter && !showMobileNav" class="options wrapFilter">
        <!-- <BaseSelect
          :options="transactionTypes"
          :placeholder="$t('app.invoice-overview.transType')"
          :value ="selectedTransactionTypeName"
          @selected="setSelectedTransactionType"
        /> -->
        <dropdown-one
          v-model="selectedTransactionType"
          :dropdownLabel="'label'"
          :options="TRANSACTION_TYPE_NEW"
          class="mt-5 mr-spacing input-wrap-apply"
          :placeholder="$t('app.create-invoice.transactionType')"
          :label="''"
          :translate="true"
          :erasable="true"
          @delete="removeSelectedTransactionTypeNew"
          @optionSelected="setSelectedTransactionTypeNew"
        />
        <!-- <BaseSelect
          :options="invoiceTypes"
          :placeholder="$t('app.invoice-overview.invType')"
          :value ="selectedInvoiceTypeName"
          @selected="setSelectedInvoiceType"
        /> -->
        <dropdown-one
          v-model="selectedInvoiceType"
          :dropdownLabel="'label'"
          :options="INVOICE_TYPES_NEW"
          class="mt-5 mr-spacing input-wrap-apply"
          :placeholder="$t('app.create-invoice.invoiceType')"
          :label="''"
          :translate="true"
          :erasable="true"
          @delete="removeSelectedInvoiceTypeNew"
          @optionSelected="setSelectedInvoiceTypeNew"
        />
       
        <DateInput 
          :placeholder="$t('app.invoice-overview.dateFrom')"
          :max="to"
          :reset="resetSearch"
          @input="(val) => (from = val)"
          style="min-width:180px; width:180px"
        />
        <DateInput 
          style="min-width:180px; width:180px"
          @input="(val) => (to = val)"
          :min="from"
          :reset="resetSearch"
          :placeholder="$t('app.invoice-overview.dateTo')" 
          />
        <div class="wrapCheckBox">
          <input type="checkbox" v-model="list_failed" name="" id="list_failed">
          <label for="list_failed">Prikaži neuspele račune</label>
        </div>
        
        <button class="btn gen" @click="getReset" style="margin-top:15px">
          {{ $t("app.invoice-overview.resetBtn") }}
        </button>
         
      </div>
      </transition>


      <div class="change-view">
        <div
          class="grid-view"
          @click="changeLayout(false)"
          :class="{ active: !isListView }"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.42857C0 1.04969 0.15051 0.686328 0.418419 0.418419C0.686328 0.15051 1.04969 0 1.42857 0H4.28571C4.6646 0 5.02796 0.15051 5.29587 0.418419C5.56378 0.686328 5.71429 1.04969 5.71429 1.42857V4.28571C5.71429 4.6646 5.56378 5.02796 5.29587 5.29587C5.02796 5.56378 4.6646 5.71429 4.28571 5.71429H1.42857C1.04969 5.71429 0.686328 5.56378 0.418419 5.29587C0.15051 5.02796 0 4.6646 0 4.28571V1.42857ZM7.14286 1.42857C7.14286 1.04969 7.29337 0.686328 7.56128 0.418419C7.82919 0.15051 8.19255 0 8.57143 0H11.4286C11.8075 0 12.1708 0.15051 12.4387 0.418419C12.7066 0.686328 12.8571 1.04969 12.8571 1.42857V4.28571C12.8571 4.6646 12.7066 5.02796 12.4387 5.29587C12.1708 5.56378 11.8075 5.71429 11.4286 5.71429H8.57143C8.19255 5.71429 7.82919 5.56378 7.56128 5.29587C7.29337 5.02796 7.14286 4.6646 7.14286 4.28571V1.42857ZM14.2857 1.42857C14.2857 1.04969 14.4362 0.686328 14.7041 0.418419C14.972 0.15051 15.3354 0 15.7143 0H18.5714C18.9503 0 19.3137 0.15051 19.5816 0.418419C19.8495 0.686328 20 1.04969 20 1.42857V4.28571C20 4.6646 19.8495 5.02796 19.5816 5.29587C19.3137 5.56378 18.9503 5.71429 18.5714 5.71429H15.7143C15.3354 5.71429 14.972 5.56378 14.7041 5.29587C14.4362 5.02796 14.2857 4.6646 14.2857 4.28571V1.42857ZM0 8.57143C0 8.19255 0.15051 7.82919 0.418419 7.56128C0.686328 7.29337 1.04969 7.14286 1.42857 7.14286H4.28571C4.6646 7.14286 5.02796 7.29337 5.29587 7.56128C5.56378 7.82919 5.71429 8.19255 5.71429 8.57143V11.4286C5.71429 11.8075 5.56378 12.1708 5.29587 12.4387C5.02796 12.7066 4.6646 12.8571 4.28571 12.8571H1.42857C1.04969 12.8571 0.686328 12.7066 0.418419 12.4387C0.15051 12.1708 0 11.8075 0 11.4286V8.57143ZM7.14286 8.57143C7.14286 8.19255 7.29337 7.82919 7.56128 7.56128C7.82919 7.29337 8.19255 7.14286 8.57143 7.14286H11.4286C11.8075 7.14286 12.1708 7.29337 12.4387 7.56128C12.7066 7.82919 12.8571 8.19255 12.8571 8.57143V11.4286C12.8571 11.8075 12.7066 12.1708 12.4387 12.4387C12.1708 12.7066 11.8075 12.8571 11.4286 12.8571H8.57143C8.19255 12.8571 7.82919 12.7066 7.56128 12.4387C7.29337 12.1708 7.14286 11.8075 7.14286 11.4286V8.57143ZM14.2857 8.57143C14.2857 8.19255 14.4362 7.82919 14.7041 7.56128C14.972 7.29337 15.3354 7.14286 15.7143 7.14286H18.5714C18.9503 7.14286 19.3137 7.29337 19.5816 7.56128C19.8495 7.82919 20 8.19255 20 8.57143V11.4286C20 11.8075 19.8495 12.1708 19.5816 12.4387C19.3137 12.7066 18.9503 12.8571 18.5714 12.8571H15.7143C15.3354 12.8571 14.972 12.7066 14.7041 12.4387C14.4362 12.1708 14.2857 11.8075 14.2857 11.4286V8.57143ZM0 15.7143C0 15.3354 0.15051 14.972 0.418419 14.7041C0.686328 14.4362 1.04969 14.2857 1.42857 14.2857H4.28571C4.6646 14.2857 5.02796 14.4362 5.29587 14.7041C5.56378 14.972 5.71429 15.3354 5.71429 15.7143V18.5714C5.71429 18.9503 5.56378 19.3137 5.29587 19.5816C5.02796 19.8495 4.6646 20 4.28571 20H1.42857C1.04969 20 0.686328 19.8495 0.418419 19.5816C0.15051 19.3137 0 18.9503 0 18.5714V15.7143ZM7.14286 15.7143C7.14286 15.3354 7.29337 14.972 7.56128 14.7041C7.82919 14.4362 8.19255 14.2857 8.57143 14.2857H11.4286C11.8075 14.2857 12.1708 14.4362 12.4387 14.7041C12.7066 14.972 12.8571 15.3354 12.8571 15.7143V18.5714C12.8571 18.9503 12.7066 19.3137 12.4387 19.5816C12.1708 19.8495 11.8075 20 11.4286 20H8.57143C8.19255 20 7.82919 19.8495 7.56128 19.5816C7.29337 19.3137 7.14286 18.9503 7.14286 18.5714V15.7143ZM14.2857 15.7143C14.2857 15.3354 14.4362 14.972 14.7041 14.7041C14.972 14.4362 15.3354 14.2857 15.7143 14.2857H18.5714C18.9503 14.2857 19.3137 14.4362 19.5816 14.7041C19.8495 14.972 20 15.3354 20 15.7143V18.5714C20 18.9503 19.8495 19.3137 19.5816 19.5816C19.3137 19.8495 18.9503 20 18.5714 20H15.7143C15.3354 20 14.972 19.8495 14.7041 19.5816C14.4362 19.3137 14.2857 18.9503 14.2857 18.5714V15.7143Z"
              fill="#DDDFE4"
            />
          </svg>
        </div>
        <div
          class="list-view"
          @click="changeLayout(true)"
          :class="{ active: isListView }"
        >
          <svg
            width="23"
            height="20"
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.66665 8.21429V11.7857C6.66665 12.3775 6.18696 12.8571 5.59522 12.8571H1.07143C0.479688 12.8571 0 12.3775 0 11.7857V8.21429C0 7.62254 0.479688 7.14286 1.07143 7.14286H5.59522C6.18696 7.14286 6.66665 7.62254 6.66665 8.21429ZM0 15.3571V18.9286C0 19.5203 0.479688 20 1.07143 20H5.59522C6.18696 20 6.66665 19.5203 6.66665 18.9286V15.3571C6.66665 14.7654 6.18696 14.2857 5.59522 14.2857H1.07143C0.479688 14.2857 0 14.7654 0 15.3571ZM5.59522 0H1.07143C0.479688 0 0 0.479688 0 1.07143V4.64286C0 5.2346 0.479688 5.71429 1.07143 5.71429H5.59522C6.18696 5.71429 6.66665 5.2346 6.66665 4.64286V1.07143C6.66665 0.479688 6.18696 0 5.59522 0ZM9.16665 20H21.7857C22.3775 20 22.8571 19.5203 22.8571 18.9286V15.3571C22.8571 14.7654 22.3775 14.2857 21.7857 14.2857H9.16665C8.57491 14.2857 8.09522 14.7654 8.09522 15.3571V18.9286C8.09522 19.5203 8.57491 20 9.16665 20ZM8.09522 1.07143V4.64286C8.09522 5.2346 8.57491 5.71429 9.16665 5.71429H21.7857C22.3775 5.71429 22.8571 5.2346 22.8571 4.64286V1.07143C22.8571 0.479688 22.3775 0 21.7857 0H9.16665C8.57491 0 8.09522 0.479688 8.09522 1.07143ZM9.16665 12.8571H21.7857C22.3775 12.8571 22.8571 12.3775 22.8571 11.7857V8.21429C22.8571 7.62254 22.3775 7.14286 21.7857 7.14286H9.16665C8.57491 7.14286 8.09522 7.62254 8.09522 8.21429V11.7857C8.09522 12.3775 8.57491 12.8571 9.16665 12.8571Z"
              fill="#DDDFE4"
            />
          </svg>
        </div>
      </div>

    </div>
    <div v-if="!isListView && invoicesList.length > 0" class="page-content">
      <single-item-icon-view 
        v-for="(invoice, index) in invoicesList"
        :key="index"
        :invoice="invoice"
        @click="goToInvoice(invoice.bll_id)"
      />

      <!-- <div
        class="single-item"
        v-for="(invoice, index) in invoicesList"
        :key="index"
        @click="goToInvoice(invoice.bll_id)"
      >
        <div class="item-image">
          <img src="../../assets/images/test-img.jpeg" alt="" />
        </div>
        <div class="item-name">{{ invoice.bll_invoice_number }}</div>
        <div class="item-info">{{ invoice.bll_date }}</div>
      </div> -->
    </div>
    <div v-if="isListView && invoicesList.length > 0" class="list-view">
      <div class="list-wrap">
        <div class="list-header">
          <div class="mobile-tweak">
            <span>{{
              $t("app.invoice-overview.invoiceNumHeader").toLocaleUpperCase()
            }}</span>
            <span v-if="isBurger">{{
              $t(
                "app.invoice-overview.invoiceReferentNumberHeader"
              ).toLocaleUpperCase()
            }}</span>
          </div>
          <!-- <span>{{ $t("app.invoice-overview.invoiceNumHeader").toLocaleUpperCase() }}</span> -->
          <span>{{
            $t("app.invoice-overview.invoiceInfoHeader").toLocaleUpperCase()
          }}</span>
          <span>{{
            $t("app.invoice-overview.invoiceDueHeader").toLocaleUpperCase()
          }}</span>
          <span v-if="!isBurger">{{
            $t(
              "app.invoice-overview.invoiceReferentNumberHeader"
            ).toLocaleUpperCase()
          }}</span>
        </div>
        <div class="list-content">
          <div
            v-for="(invoice, index) in invoicesList"
            :key="index"
            class="list-item"
            :class="{ alt: index % 2 === 1 }"
            @click="goToInvoice(invoice.bll_id)"
          >
            <div class="list-item-name">
              <span>{{ invoice.bll_id }}</span>
            </div>
            <div class="list-item-info">{{ invoice.bll_date }}</div>
            <div class="list-item-due">{{ invoice.total }}</div>
            <div v-if="!isBurger" class="list-item-barcode">
              {{ invoice.bll_invoice_number }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isBurger" class="invoice-img-wrap">
        <img src="../../assets/images/invoice-img.png" alt="" />
      </div>
    </div>
    <div v-if="invoicesList.length > 0" class="content-footer">
      <div class="pagination">
        <Pagination
          :activePage="page"
          :pages="pagesCount"
          @setActive="changePage"
        />
      </div>
      <div 
        v-if="pagesCount" 
        class="total-results">
        {{
          $t("app.invoice-overview.results", {
            current: `${currentPagesStart} - ${currentPagesEnd}`,
            total: invoicesCount,
          })
        }}
      </div>
    </div>
    <div v-if="invoicesList.length <= 0" class="no-invoices">
      <div class="info-wrapper">
        <div class="create-new-text">
          {{ $t("app.invoice-overview.noInvoices") }}
        </div>
        <button class="btn new" @click="goToCreateInvoice" >
          {{ $t("app.invoice-overview.createNewBtn") }}
        </button>
      </div>
      <div class="img-wrapper">
        <img src="../../assets/images/no-invoice-found.png" alt="" />
      </div>
    </div>
  </div>
  <router-view v-else />
</template>

<script setup>
import api from "@/api/index.js";
import { useClientsStore } from "@/store/clientsStore";
import { objectKeysToArr } from "@/assets/js/helpers";
import { TRANSACTION_TYPE, INVOICE_TYPES,INVOICE_TYPES_NEW, TRANSACTION_TYPE_NEW  } from "@/assets/js/types";
import { ModalStore } from "@/store/modalStore";

const modalStore = ModalStore();

const router = useRouter();
const clientsStore = useClientsStore();
let isMobile = inject("isMobile");
let isBurger = inject("isBurger");
let isListView = ref(true);
let hasContent = ref(true);
let showFilter = ref(false);

//DATA
let invoicesList = ref([]);
let invoicesCount = ref(1);

//PAGINATION
let pagCount = ref(12);
let page = ref(1);
let selectedTransactionType = ref(null);
let selectedInvoiceType = ref(null);
let selectedTransactionTypeName = ref(null);
let selectedInvoiceTypeName = ref(null);
let searchByKey = ref("");

// Select date param 
const from = ref();
const to = ref();

const list_failed = ref(false);
const resetSearch = ref(false);


async function getInvoices() {
 if(!clientsStore.currentClient)
  return
  try {
    const cli_id = clientsStore.currentClient.cli_id;
    let params = {
      cli_id: cli_id,
      count: pagCount.value,
      offset: (page.value - 1) * pagCount.value,
      // test: selectedTransactionType.value,
      // test1: selectedInvoiceType.value,
      // search: searchByKey.value,
    };
    if(selectedTransactionType.value){
      params.bll_transaction_type = selectedTransactionType.value.id;
    }
    if(selectedInvoiceType.value){
      params.bll_invoice_type = selectedInvoiceType.value.id;
    }
    if(searchByKey.value !== ''){
      params.search = searchByKey.value;
    }
    if(from.value){
      params.start = from.value;
    }
    if(to.value){
      params.end = to.value;
    }
    if(list_failed.value){
      params.list_failed = 1;
    }


    let res = await api.getAllInvoices(params);
    if (res.status === 200) {
      invoicesList.value = res.data.data;
      invoicesCount.value = res.data.meta_info.count;
    }
  } catch (error) {
    console.error(error);
  }
}

async function changePage(newPage) {
  if (newPage !== page.value) {
    page.value = newPage;
    getInvoices();
  }
}

const changeLayout = (bool) => {
  isListView.value = bool;
};

const goToCreateInvoice = () => {
  router.push("/invoice-issuing");
};

const goToInvoice = (invoiceId) => {
  router.push({
    name: "ViewInvoice",
    params: {
      id: invoiceId,
    },
  });
};

const pagesCount = computed(() => {
  return Math.ceil(invoicesCount.value / pagCount.value);
});
const currentPagesStart = computed(() => {
  return page.value * pagCount.value - (pagCount.value - 1);
});
const currentPagesEnd = computed(() => {
  if (pagesCount.value === page.value) {
    // console.log(invoicesCount.value);
    return invoicesCount.value;
  } else {
    return page.value * pagCount.value;
  }
});

// const setSelectedTransactionType = (type) => {
//   // console.log(type);
//   selectedTransactionTypeName.value = type
//   selectedTransactionType.value = TRANSACTION_TYPE[type];
//   // console.log(selectedTransactionType.value);
// };
const setSelectedTransactionTypeNew = (val) => {
  selectedTransactionType.value = val;
};
const removeSelectedTransactionTypeNew = () => {
  selectedTransactionType.value = null;
};

// const setSelectedInvoiceType = (type) => {
//   selectedInvoiceTypeName.value = type
//   selectedInvoiceType.value = INVOICE_TYPES[type];
//   // console.log(selectedInvoiceType.value);
// };
const setSelectedInvoiceTypeNew = (val) => {
  selectedInvoiceType.value = val;
};
const removeSelectedInvoiceTypeNew = () => {
  selectedInvoiceType.value = null;
};
const transactionTypes = computed(() => {
  return objectKeysToArr(TRANSACTION_TYPE);
});

const invoiceTypes = computed(() => {
  return objectKeysToArr(INVOICE_TYPES);
});

function search(val){
  searchByKey.value = val
}

watch(
  [
    () => selectedTransactionType.value,
    () => selectedInvoiceType.value,
    () => searchByKey.value,
    () => from.value,
    () => to.value,
    () => list_failed.value
  ],
  ()=>{
    page.value = 1;
    getInvoices();
  }
);

const showMobileNav = ref(false)
function resize () {
  // console.log('resize' + window.innerWidth)
    if (window.innerWidth <= 600) {
    showMobileNav.value = true
    } else {
      showMobileNav.value = false
    if(modalStore.getModalData !== null)
     modalStore.setModalData(null);
    }
  }

onMounted(async () => {
  resize();
  window.addEventListener("resize", resize)
  await getInvoices();
});
onUnmounted(() => {
  window.removeEventListener("resize", resize)
})

//FILTER
function showHideFilters(){
  if(showMobileNav.value) {
    openModal()
  }else{
    showFilter.value = !showFilter.value
  }
}

// MODAL
function openModal(){
  const data = {
    component: "filterModal",
    title: '',
    options: {
      update: (dataObj) => {
        // console.log(dataObj)
        setData(dataObj)
        
      },
      transactionTypes:transactionTypes,
      invoiceTypes,
      styleParent:"width:100vw; height:calc( 100vh - 58px ); position:absolute; bottom:0",
      styleContent: "height:calc( 100% - 55px )"

    }
  }
  modalStore.setModalData(data);
}
function setData(dataObj){
  if(dataObj.selectedTransactionType && dataObj.selectedTransactionType != '')
    selectedTransactionType.value = dataObj.selectedTransactionType

  if(dataObj.selectedInvoiceType && dataObj.selectedInvoiceType != '')
    selectedInvoiceType.value = dataObj.selectedInvoiceType

  if(dataObj.from && dataObj.from != '')
    from.value = dataObj.from

  if(dataObj.to && dataObj.to != '')
    to.value = dataObj.to
}

function getReset(){
    selectedTransactionType.value = null;
    selectedInvoiceType.value = null;
    searchByKey.value = "";
    from.value = null;
    to.value = null;
    list_failed.value = false;

    //
    selectedInvoiceTypeName.value = null;
    selectedTransactionTypeName.value = null;
    resetSearch.value = !resetSearch.value;


  }

</script>

<style lang="scss" scoped>
.active {
  svg {
    path {
      fill: $main-green;
    }
  }
}
.content-footer {
  margin-top: 20px;
  display: flex;
  .total-results {
    padding-top: 10px;
  }
}
.content-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .content-bar-left,
  .content-bar-right {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
  }
  .content-bar-left {
    // margin-right: 1vw;
    .multiselect-wrap,.search-wrap{
      margin-right: 5px;
    }
  }
}
.component-wrap {
  .mobile-filter-bar {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    .options {
      display: flex;
      justify-content: space-between;
      .options-right {
        display: flex;
        margin-left: $spacing-margine;
        .filter {
          cursor: pointer;
          outline: none;
          border: none;
          width: 85px;
          height: 38px;
          background: #ffffff;
          border-radius: 30px;
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          color: $main-green;
          margin-right: $spacing-margine;
          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));
        }

        .create-invoice {
          border: none;
          height: 38px;
          width: 38px;
          background: $main-green;
          border-radius: 50%;
          color: #ffffff;

          .material-symbols-rounded {
            font-size: 30px;
            font-variation-settings: "FILL" 1, "wght" 700, "GRAD" 0, "opsz" 48;
          }
        }
      }
    }

    .change-view {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-end;

      .grid-view,
      .list-view {
        cursor: pointer;
        width: 23px;
        height: 20px;
      }

      .grid-view {
        margin-right: 15px;
      }
    }
  }
}


.wrapFilter{
  padding-top: 20px;
  justify-content: space-evenly !important;
  flex-wrap: wrap;
  div{
    width: 25%;
    margin: 15px 15px 0 15px;
    min-width: 180px;

  }
}
.wrapCheckBox{
  display: flex;
  align-items: center;

  input{
    margin: 0;
    margin-right: 10px;
  }
  label {
    margin: 0;
    color: #acacad;
      font-weight: 400;
      font-size: $placeholder-size;
      line-height: 14px;
  }
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.3s;
  opacity: 1;
  max-height: 250px;
}
.fadeHeight-enter,
.fadeHeight-leave-to
{
  transition: all 0.3s;
  opacity: 0;
  max-height: 0px;
}

@media only screen and (max-width: 1860px) {
  .content-bar-left,
  .content-bar-right {
    justify-content: space-between !important;
    * {
      margin: 0 15px 15px;
    }
  }
}
</style>
<style lang="scss">
.fix-margin-top{
  .dropdown-one-wrapper{
    margin-top: 0;
    margin-right: 0;
    max-width: 280px;
  }
}
</style>
